module.exports = __webpack_public_path__ + "static/img/reyzarConceeptPic1.38dfc1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/reyzarConceeptPic1.png
// module id = Cb47
// module chunks = 0